import { RouteMapping } from './route-mapping.js';
const adminRoutes = {
    IndexPage: {
        path: '/',
        pageName: 'IndexPage',
        component: 'IndexPageScreen',
        protectedRoute: true,
        authorizedFor: [],
        pathParams: [],
        queryParams: [],
        nestedRoutes: {},
        redirectRules() {
            return [];
        }
    },
    EngagementDataPage: {
        path: '/engagement',
        pageName: 'EngagementDataPage',
        component: 'EngagementDataScreen',
        protectedRoute: true,
        authorizedFor: [],
        pathParams: [],
        queryParams: ['section'],
        nestedRoutes: {},
        redirectRules() {
            return [];
        }
    }
};
export class AdminRouteMapping extends RouteMapping {
    constructor() {
        super(adminRoutes);
    }
}
//# sourceMappingURL=admin.js.map